import { action as apiAction } from 'api/Api'
import {
  setStartDate,
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
}

const requestRemoveStartDate = (payload: Payload) => async dispatch => {
  const { cardId } = payload

  const optimisticAction = optimisticDispatch(dispatch, setStartDate({
    id: cardId,
    startDate: null
  }))

  try {
    await apiAction('RemoveStartDate', {
      cardId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestRemoveStartDate
